import {
  CheckCircleIcon,
  ExclamationIcon,
  InformationCircleIcon,
  XCircleIcon,
} from '../icons/index.js'
import { AlertStatus } from './types.js'

export type AlertIconProps = {
  status: AlertStatus
}

export const AlertIcon = ({ status }: AlertIconProps) => {
  switch (status) {
    case 'error':
      return <XCircleIcon />
    case 'warning':
      return <ExclamationIcon />
    case 'success':
      return <CheckCircleIcon />
    case 'info':
      return <InformationCircleIcon />
    case 'neutral':
    default:
      return null
  }
}
